/**
 * 接口公共参数
*/
export const SqlBase = () => {
  return [
    {
      type: 'doubleSum',
      name: 'goodsWeight',
      fieldName: 'goodsWeight',
    },
    {
      type: 'doubleSum',
      name: 'goodsVolume',
      fieldName: 'goodsVolume',
    },
    {
      type: 'longSum',
      name: 'piece',
      fieldName: 'piece',
    },
    {
      type: 'longSum',
      name: 'ticket',
      fieldName: 'ticket',
    }
  ]
}